import { Channel } from './channel';

export const applicationChannel = {
  version: {
    frontendChanged: new Channel(),
  },
};
